<template>
  <div class="side-menu-wrapper">
    <slot></slot>
    <Menu ref="menu" v-show="!collapsed" :active-name="activeName" :open-names="openedNames" :accordion="accordion" :theme="theme" width="auto" @on-select="handleSelect">
      <template v-for="item in menuList">
        <template v-if="item[$config.router.childrenKey] && item[$config.router.childrenKey].length === 1">
          <side-menu-item v-if="showChildren(item) && item[$config.router.isMenuKey]" :key="`menu-${item[$config.router.idKey]}`" :parent-item="item"></side-menu-item>
          <menu-item v-if="!showChildren(item) && item[$config.router.isMenuKey]" :name="item[$config.router.urlKey]" :to="item[$config.router.urlKey]" :key="`menu-${item[$config.router.idKey]}`"><i :class="item[$config.router.childrenKey][0][$config.router.iconKey] || ''"></i><span>{{ showTitle(item[$config.router.childrenKey][0]) }}</span></menu-item>
        </template>
        <template v-else>
          <side-menu-item v-if="showChildren(item) && item[$config.router.isMenuKey]" :key="`menu-${item[$config.router.idKey]}`" :parent-item="item"></side-menu-item>
          <menu-item v-if="!showChildren(item) && item[$config.router.isMenuKey]" :name="item[$config.router.urlKey]" :to="item[$config.router.urlKey]" :key="`menu-${item[$config.router.idKey]}`"><i :class="item[$config.router.iconKey] || ''"></i><span>{{ showTitle(item) }}</span></menu-item>
        </template>
      </template>
    </Menu>
    <div class="menu-collapsed" v-show="collapsed" :list="menuList">
      <template v-for="item in menuList">
        <collapsed-menu v-if="item[$config.router.childrenKey] && item[$config.router.childrenKey].length > 0" @on-click="handleSelect" hide-title :root-icon-size="rootIconSize" :icon-size="iconSize" :theme="theme" :parent-item="item" :key="`drop-menu-${item[$config.router.idKey]}`"></collapsed-menu>
        <Tooltip transfer v-else :content="(item[$config.router.labelKey]) || (item[$config.router.childrenKey] && item[$config.router.childrenKey][0] && item[$config.router.childrenKey][0][$config.router.labelKey])" placement="right" :key="`drop-menu-${item[$config.router.idKey]}`">
          <a @click="handleSelect(getNameOrHref(item, true))" class="drop-menu-a" :style="{textAlign: 'center'}"><i :class="item[$config.router.iconKey] || (item[$config.router.childrenKey] && item[$config.router.childrenKey][0][$config.router.iconKey])"></i></a>
        </Tooltip>
      </template>
    </div>
  </div>
</template>
<script>
import SideMenuItem from './side-menu-item.vue'
import CollapsedMenu from './collapsed-menu.vue'
import { getUnion } from '@/libs/tools'
import mixin from './mixin'

export default {
  name: 'SideMenu',
  mixins: [ mixin ],
  components: {
    SideMenuItem,
    CollapsedMenu
  },
  props: {
    menuList: {
      type: Array,
      default () {
        return []
      }
    },
    collapsed: {
      type: Boolean
    },
    theme: {
      type: String,
      default: 'dark'
    },
    rootIconSize: {
      type: Number,
      default: 20
    },
    iconSize: {
      type: Number,
      default: 16
    },
    accordion: Boolean,
    activeName: {
      type: String,
      default: ''
    },
    openNames: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      openedNames: []
    }
  },
  methods: {
    handleSelect (name) {
      this.$emit('on-select', name)
    },
    getOpenedNamesByActiveName (name) {
      return this.$route.matched.map(item => item.path).filter(item => item !== name)
    },
    updateOpenName (name) {
      if (name === 'home') this.openedNames = []
      else this.openedNames = this.getOpenedNamesByActiveName(name)
    }
  },
  computed: {
    textColor () {
      return this.theme === 'dark' ? '#fff' : '#495060'
    }
  },
  watch: {
    activeName (name) {
      if (this.accordion) this.openedNames = this.getOpenedNamesByActiveName(name)
      else this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(name))
    },
    openNames (newNames) {
      this.openedNames = newNames
    },
    openedNames () {
      this.$nextTick(() => {
        this.$refs.menu.updateOpened()
      })
    }
  },
  mounted () {
    this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(name))
  }
}
</script>
<style lang="less">
@import './side-menu.less';
</style>



// WEBPACK FOOTER //
// src/view/main/components/side-menu/side-menu.vue